const qcNoteNL = {
    "view": {
        "message": {
            "releaseHasQCIssues": "Release {{releaseName}} heeft QC-problemen, bewerk de release voor gedetailleerde QC-feedback, voer de vereiste wijzigingen door en dien opnieuw in!",
            "trackHasQCIssues": "Track {{trackName}} heeft QC-problemen, bewerk de track voor gedetailleerde QC-feedback, voer de vereiste wijzigingen door en dien opnieuw in!"
        }
    }
};

export default qcNoteNL;